import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons'
import { Center, Stack, Box } from '@chakra-ui/react'
import React from 'react'
import { colors } from '../../../ui-kit'

const PageNavigator = ({
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  gotoPage,
}: {
  pageIndex: number
  pageCount: number
  canPreviousPage: boolean
  canNextPage: boolean
  previousPage(): void
  nextPage(): void
  gotoPage(updater: number): void
}): React.ReactElement => {
  return(
  <Stack direction={['row']} align="center" spacing={2}>
    <Box
      cursor="pointer"
      padding="7px"
      color={canPreviousPage ? colors.appBlue : colors.appBlueyGrey}
      onClick={() => {
        gotoPage(0)
      }}
    >
      <ArrowLeftIcon h={3} w={3} />
    </Box>
    <Box
      cursor="pointer"
      padding="7px"
      color={canPreviousPage ? colors.appBlue : colors.appBlueyGrey}
      onClick={previousPage}
    >
      <ChevronLeftIcon h={6} w={6} />
    </Box>
    {pageCount < 6 &&
      Array.from(Array(pageCount).keys()).map(i => (
        <Center
          key={i}
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={
            pageIndex === i ? colors.appPaleGreyThree : colors.appWhite
          }
          onClick={() => {
            gotoPage(i)
          }}
        >
          {i + 1}
        </Center>
      ))}
    {pageCount >= 6 && pageIndex <= 2 && (
      <React.Fragment>
        {Array.from(Array(pageCount).keys())
          .filter(i => i < 4)
          .map(i => (
            <Center
              key={i}
              cursor="pointer"
              height="3em"
              width="3em"
              borderRadius="3px"
              backgroundColor={
                pageIndex === i ? colors.appPaleGreyThree : colors.appWhite
              }
              onClick={() => {
                gotoPage(i)
              }}
            >
              {i + 1}
            </Center>
          ))}
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
        >
          --
        </Center>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
          onClick={() => {
            gotoPage(pageCount - 1)
          }}
        >
          {pageCount}
        </Center>
      </React.Fragment>
    )}
    {pageCount >= 6 && pageIndex >= pageCount - 3 && (
      <React.Fragment>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
          onClick={() => {
            gotoPage(0)
          }}
        >
          {1}
        </Center>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
        >
          --
        </Center>
        {Array.from(Array(pageCount).keys())
          .filter(i => i >= pageCount - 4)
          .map(i => (
            <Center
              key={i}
              cursor="pointer"
              height="3em"
              width="3em"
              borderRadius="3px"
              backgroundColor={
                pageIndex === i ? colors.appPaleGreyThree : colors.appWhite
              }
              onClick={() => {
                gotoPage(i)
              }}
            >
              {i + 1}
            </Center>
          ))}
      </React.Fragment>
    )}
    {pageCount >= 6 && pageIndex < pageCount - 3 && pageIndex > 2 && (
      <React.Fragment>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
          onClick={() => {
            gotoPage(0)
          }}
        >
          {1}
        </Center>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
        >
          --
        </Center>
        {Array.from(Array(pageCount).keys())
          .filter(
            i => i === pageIndex - 1 || i === pageIndex || i === pageIndex + 1,
          )
          .map(i => (
            <Center
              key={i}
              cursor="pointer"
              height="3em"
              width="3em"
              borderRadius="3px"
              backgroundColor={
                pageIndex === i ? colors.appPaleGreyThree : colors.appWhite
              }
              onClick={() => {
                gotoPage(i)
              }}
            >
              {i + 1}
            </Center>
          ))}
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
        >
          --
        </Center>
        <Center
          cursor="pointer"
          height="3em"
          width="3em"
          borderRadius="3px"
          backgroundColor={colors.appWhite}
          onClick={() => {
            gotoPage(pageCount - 1)
          }}
        >
          {pageCount}
        </Center>
      </React.Fragment>
    )}
    <Box
      cursor="pointer"
      padding="7px"
      color={canNextPage ? colors.appBlue : colors.appBlueyGrey}
      onClick={nextPage}
    >
      <ChevronRightIcon h={6} w={6} />
    </Box>
    <Box
      cursor="pointer"
      padding="7px"
      color={canNextPage ? colors.appBlue : colors.appBlueyGrey}
      onClick={() => void gotoPage(pageCount - 1)}
    >
      <ArrowRightIcon h={3} w={3} />
    </Box>
  </Stack>
)}

export default PageNavigator
